import React from 'react';
import MuiCheckbox from '@mui/material/Checkbox';

const getBoxStyle = (borderColor) => ({
  width: 18,
  height: 18,
  border: `2px solid ${borderColor}`,
  borderRadius: 4,
  boxSizing: 'border-box',
  backgroundColor: '#fff',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  lineHeight: 0,
});

const CustomCheckbox = ({
  icon,
  borderColor = 'rgb(216 199 40)',
  checked = false,
  onChange,
  style,
  ...rest
}) => {
  const boxStyle = getBoxStyle(borderColor);
  const handleChange = (event, isChecked) => {
    if (typeof onChange === 'function') {
      onChange(isChecked, event);
    }
  };

  return (
    <MuiCheckbox
      checked={checked}
      onChange={handleChange}
      icon={<span style={boxStyle} />}
      checkedIcon={<span style={boxStyle}>{icon}</span>}
      disableRipple
      sx={{
        p: 0,
        color: 'transparent',
        '&:hover': {
          backgroundColor: 'transparent',
        },
      }}
      style={style}
      {...rest}
    />
  );
};

export default CustomCheckbox;
